/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { triggerWrapperStyles } from '@atlaskit/editor-common/styles';
import { ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import ShowMoreHorizontalIcon from '@atlaskit/icon/utility/migration/show-more-horizontal--editor-more';
import { fg } from '@atlaskit/platform-feature-flags';
var MoreIconStyle = css({
  display: 'flex',
  alignItems: 'center',
  height: "var(--ds-space-300, 24px)"
});
export var MoreButton = /*#__PURE__*/React.memo(function (_ref) {
  var label = _ref.label,
    ariaExpanded = _ref['aria-expanded'],
    isReducedSpacing = _ref.isReducedSpacing,
    isSelected = _ref.isSelected,
    isDisabled = _ref.isDisabled,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown;
  return jsx(ToolbarButton, {
    disabled: isDisabled,
    selected: isSelected,
    onClick: onClick,
    onKeyDown: onKeyDown,
    spacing: isReducedSpacing ? 'none' : 'default',
    title: label,
    iconBefore:
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/platform/ensure-feature-flag-prefix -- Ignored via go/DSP-18766
    jsx("div", {
      css: fg('platform-visual-refresh-icons') ? MoreIconStyle : triggerWrapperStyles
    }, jsx(ShowMoreHorizontalIcon, {
      label: "",
      color: "currentColor",
      spacing: "spacious"
    })),
    "aria-expanded": ariaExpanded,
    "aria-label": label,
    "aria-haspopup": true
  });
});